"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoLargeFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.LogoLargeFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("g", { clipPath: "url(#clip0_4062_1481)" },
                react_1.default.createElement("path", { d: "M0 105.05C0 124.288 15.7009 140 35.0252 140H104.975C124.299 140 140 124.288 140 104.95V35.0504C139.899 15.7122 124.198 0 104.975 0H35.0252C15.7009 0 0 15.7122 0 35.0504V105.05Z", fill: "#7B67EE" }),
                react_1.default.createElement("path", { d: "M104.7 81.6001H81.6001V104.7H104.7V81.6001Z", fill: "white" }),
                react_1.default.createElement("path", { d: "M81.5998 58.3998L58.3998 81.5998L35.2998 104.7V81.5998V58.3998V35.2998H58.3998V58.3998L81.5998 35.2998H104.7L81.5998 58.3998Z", fill: "white" })),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("clipPath", { id: "clip0_4062_1481" },
                    react_1.default.createElement("rect", { width: "140", height: "140", fill: "white" }))));
    },
    name: 'logo_large_filled',
    defaultColors: ['#7B67EE', 'white'],
    colorful: true,
    allPathData: [],
    width: '140',
    height: '140',
    viewBox: '0 0 140 140',
});
